import { Search, X } from 'lucide-react';
import { FormField, FormLabel, FormInput, FormSelect, Button } from '../ui';
import { useState } from 'react';

interface BookingFilters {
  status?: string;
  date_start?: string;
  date_end?: string;
  professional_id?: number;
  service_type_id?: number;
  contact_id?: number;
  page?: number;
  limit?: number;
}

interface BookingFiltersProps {
  filters: BookingFilters;
  onFilterChange: (filters: BookingFilters) => void;
  onResetFilters: () => void;
  professionals: any[];
  serviceTypes: any[];
}

function BookingFilters({
  filters,
  onFilterChange,
  onResetFilters,
  professionals,
  serviceTypes,
}: BookingFiltersProps) {
  const [localFilters, setLocalFilters] = useState<BookingFilters>({
    ...filters,
  });

  const handleLocalFilterChange = (name: string, value: string) => {
    setLocalFilters(prev => ({
      ...prev,
      [name]: value || undefined,
    }));
  };

  const handleApplyFilters = () => {
    onFilterChange({
      ...localFilters,
      page: 1, // Reset to first page when filters change
    });
  };

  const isFiltered = Object.keys(filters).some(
    key => key !== 'page' && key !== 'limit' && filters[key as keyof BookingFilters]
  );

  return (
    <div className="bg-white dark:bg-gray-800 p-4 rounded-lg shadow mb-6">
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
        <FormField>
          <FormLabel htmlFor="status">Status</FormLabel>
          <FormSelect
            id="status"
            name="status"
            value={localFilters.status || ''}
            onChange={e => handleLocalFilterChange('status', e.target.value)}
          >
            <option value="">Todos</option>
            <option value="booked">Reservado</option>
            <option value="confirmed">Confirmado</option>
            <option value="canceled">Cancelado</option>
          </FormSelect>
        </FormField>

        <FormField>
          <FormLabel htmlFor="date_start">Data Início</FormLabel>
          <FormInput
            type="date"
            id="date_start"
            name="date_start"
            value={localFilters.date_start || ''}
            onChange={e => handleLocalFilterChange('date_start', e.target.value)}
          />
        </FormField>

        <FormField>
          <FormLabel htmlFor="date_end">Data Fim</FormLabel>
          <FormInput
            type="date"
            id="date_end"
            name="date_end"
            value={localFilters.date_end || ''}
            onChange={e => handleLocalFilterChange('date_end', e.target.value)}
          />
        </FormField>

        <FormField>
          <FormLabel htmlFor="professional_id">Profissional</FormLabel>
          <FormSelect
            id="professional_id"
            name="professional_id"
            value={localFilters.professional_id?.toString() || ''}
            onChange={e => handleLocalFilterChange('professional_id', e.target.value)}
          >
            <option value="">Todos</option>
            {professionals?.map(professional => (
              <option key={professional.id} value={professional.id}>
                {professional.name}
              </option>
            ))}
          </FormSelect>
        </FormField>

        <FormField>
          <FormLabel htmlFor="service_type_id">Tipo de Serviço</FormLabel>
          <FormSelect
            id="service_type_id"
            name="service_type_id"
            value={localFilters.service_type_id?.toString() || ''}
            onChange={e => handleLocalFilterChange('service_type_id', e.target.value)}
          >
            <option value="">Todos</option>
            {serviceTypes?.map(serviceType => (
              <option key={serviceType.id} value={serviceType.id}>
                {serviceType.name}
              </option>
            ))}
          </FormSelect>
        </FormField>
      </div>

      <div className="flex justify-end mt-4 space-x-2">
        {isFiltered && (
          <Button variant="secondary" onClick={onResetFilters} className="flex items-center">
            <X className="h-4 w-4 mr-2" />
            Limpar Filtros
          </Button>
        )}
        <Button onClick={handleApplyFilters} className="flex items-center">
          <Search className="h-4 w-4 mr-2" />
          Filtrar
        </Button>
      </div>
    </div>
  );
}

export default BookingFilters;
